var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowUpsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13659_10185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8.5C9.61396 8.5 11.125 6.98896 11.125 5.125C11.125 3.26104 9.61396 1.75 7.75 1.75C5.88604 1.75 4.375 3.26104 4.375 5.125C4.375 6.98896 5.88604 8.5 7.75 8.5Z",
    fill: "#D3E9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16457 12.924C9.1964 12.8126 9.21231 12.7569 9.23616 12.705C9.25734 12.6588 9.28314 12.615 9.31318 12.5741C9.347 12.528 9.38796 12.487 9.46988 12.4051L14.3125 7.5625C14.8303 7.04473 15.6697 7.04472 16.1875 7.56248C16.7053 8.08025 16.7053 8.91975 16.1875 9.43753L11.3449 14.2801C11.263 14.362 11.222 14.403 11.1759 14.4368C11.135 14.4669 11.0912 14.4927 11.045 14.5138C10.9931 14.5377 10.9374 14.5536 10.826 14.5854L8.5 15.25L9.16457 12.924Z",
    fill: "#D3E9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.125H5.875C4.82833 11.125 4.30499 11.125 3.87914 11.2542C2.92034 11.545 2.17003 12.2953 1.87918 13.2541C1.75 13.68 1.75 14.2033 1.75 15.25M11.125 5.125C11.125 6.98896 9.61396 8.5 7.75 8.5C5.88604 8.5 4.375 6.98896 4.375 5.125C4.375 3.26104 5.88604 1.75 7.75 1.75C9.61396 1.75 11.125 3.26104 11.125 5.125ZM8.5 15.25L10.826 14.5854C10.9374 14.5536 10.9931 14.5377 11.045 14.5138C11.0912 14.4927 11.135 14.4669 11.1759 14.4368C11.222 14.403 11.263 14.362 11.3449 14.2801L16.1875 9.43753C16.7053 8.91975 16.7053 8.08025 16.1875 7.56248C15.6697 7.04472 14.8303 7.04473 14.3125 7.5625L9.46988 12.4051C9.38796 12.487 9.347 12.528 9.31318 12.5741C9.28314 12.615 9.25734 12.6588 9.23616 12.705C9.21231 12.7569 9.1964 12.8126 9.16457 12.924L8.5 15.25Z",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13659_10185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpsIcon);
export default __webpack_public_path__ + "static/media/follow-ups-icon.9a640af0.svg";
export { ForwardRef as ReactComponent };